import React, { useRef, useState } from "react";
import Modal from "react-modal";
import { useZustandStore } from "_shared/utils/zustandStore";
import MoneylineModal from "./MoneylineModal";

Modal.setAppElement("#root");

function MoneylineColumn(props) {
    const [moneylineModal, setMoneylineModal] = useState(false);
    const timeoutRef = useRef(null);
    const moneylineDays = useZustandStore((state) => state.moneylineDays);
    const momoDict = { NEUTRAL: "hold", BEARISH: "sell", BULLISH: "buy" };
    const moneylineStatsColumnObj =
        props.cell.row.original.moneyline_stats?.[
        `tr_${props.cell.row.original.algo_daily_CALC_TRADING_RANGE_SIGNAL.toLowerCase()}`
        ]?.[`st_${momoDict[props.cell.row.original.algo_daily_30D_ST_MOMENTUM]}`]?.[
        `mt_${momoDict[props.cell.row.original.algo_daily_90D_MT_MOMENTUM]}`
        ]?.[`d${moneylineDays - 1}`];
    const moneylineStatsObj =
        props.cell.row.original.moneyline_stats?.[
        `tr_${localStorage.getItem('vip-view') === 'oversold' ? 'buy' : 'sell'}`
        ]?.[`st_${momoDict[props.cell.row.original.algo_daily_30D_ST_MOMENTUM]}`]?.[
        `mt_${momoDict[props.cell.row.original.algo_daily_90D_MT_MOMENTUM]}`
        ];
    return (
        <>
            <span
                style={{ color: props.moneylineKey === 'avg_pct_gain' ? 'green' : props.moneylineKey === 'avg_pct_loss' ? 'red' : 'white' }}
                onMouseEnter={() => {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = setTimeout(() => {
                        setMoneylineModal(true);
                    }, 1000);
                }}
                onMouseLeave={() => {
                    clearTimeout(timeoutRef.current);
                }}>
                {moneylineStatsColumnObj?.[props.moneylineKey] && props.moneylineKey === 'avg_pct_gain' ? '+' : ''}
                {moneylineStatsColumnObj?.[props.moneylineKey] ? (moneylineStatsColumnObj?.[props.moneylineKey] * 100).toFixed(1) : '--'}
            </span>
            <MoneylineModal cell={props.cell} moneylineModal={moneylineModal} setMoneylineModal={setMoneylineModal} moneylineStatsObj={moneylineStatsObj} />
        </>
    );
}
export default React.memo(MoneylineColumn);
